import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import ColorPickerComponent from 'routes/Admin/components/CommonComponents/ColorPickerComponent'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
const styles = theme => ({})

class UserModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object,
    updateUser: PropTypes.func,
    hideModal: PropTypes.func
  }
  static defaultProps = {}
  state = {
    user: {
      color: '',
      show: true
    },
    pwdBtn: true,
    showPassword: false,
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    const { user } = nextState
    const userProps = this.props.user
    let isValid = true
    let errors = {}
    if (userProps && isValid) {
      isValid = !_.isEqual(userProps, user)
    }
    if (user.password === '') {
      isValid = false
    }
    this.setState({ ...nextState, isValid, errors })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      user: { ...this.state.user, [name]: value }
    })
  }
  handlePaswordChange = e => {
    this.updateState({ user: { ...this.state.user, password: e.target.value } })
  }
  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }
  handleOnUpdate = () => {
    const { user } = this.state
    this.props.updateUser(this.props.user, { ...user })
  }
  showSwitch = classes => {
    const { user } = this.state
    return (
      <FormControlLabel
        control={
          <Switch
            checked={user.show}
            onChange={this.handleChange('show')}
            disabled={!this.props.user.passwordHash}
            value="checker"
            color="primary"
          />
        }
        label="Afficher"
      />
    )
  }
  handlePwdClick = e => {
    this.setState({ pwdBtn: false, user: { ...this.state.user, password: '' } })
  }
  componentDidMount() {
    const { user } = this.props
    let nextState = { ...this.state }
    if (user) {
      nextState = { user: { ...user } }
    }

    this.updateState(nextState)
  }
  handleColorSelection = name => color => {
    this.updateState({
      ...this.state,
      user: { ...this.state.user, [name]: color }
    })
  }
  colorPicker = classes => {
    const { user } = this.state
    return (
      <ColorPickerComponent
        className={classes.colorControl}
        colorValidate={this.handleColorSelection('color')}
        color={user.color}
      />
    )
  }
  render() {
    const { classes } = this.props
    const userProps = this.props.user
    const { isValid, user, pwdBtn } = this.state
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={this.handleOnUpdate}
        title={`Editer ${userProps.user_last_name} ${
          userProps.user_first_name
        }`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                id="last"
                label="Nom"
                disabled
                value={userProps.user_last_name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                id="first"
                label="Prénom"
                disabled
                value={userProps.user_first_name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                id="email"
                label="Nom"
                disabled
                value={userProps.user_email}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                id="api"
                label="API KEY"
                value={userProps.apiKey}
                disabled
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={12}>
              {pwdBtn && (
                <Button
                  variant="raised"
                  color="primary"
                  onClick={this.handlePwdClick}>
                  {userProps.passwordHash
                    ? 'Changer le mot de passe'
                    : 'Saisir le mot de passe'}
                </Button>
              )}
              {!pwdBtn && (
                <FormControl>
                  <InputLabel htmlFor="adornment-password">
                    Mot de passe
                  </InputLabel>
                  <Input
                    id="adornment-password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={user.password}
                    onChange={this.handlePaswordChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}>
                          {this.state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {this.colorPicker(classes)}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {this.showSwitch(classes)}
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(UserModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Users/components/UserModal.js